import React, { Component, Fragment } from 'react';
import T from 'prop-types';
// utils
import isEmpty from 'lodash.isempty';
import getPromptsNotes from '../utils/getPromptsNotes';
// redux
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getJournalPrompts,
  setActiveNote
} from '../../../redux/reducers/journals';
// components
import { Collapse } from 'react-collapse';
import NoteBlock from './NoteBlock';
import Icon from '../../../components/Icon/Icon';
import Placeholder from './Placeholder';
//styles
import styles from './JournalPrompts.mod.css';
import classnames from 'classnames/bind';

let cx = classnames.bind(styles);

class JournalPrompts extends Component {
  state = {
    collapsedModules: []
  };

  componentDidMount() {
    this.props.getJournalPrompts();
  }

  componentWillUnmount() {
    this.props.setActiveNote(null);
  }

  toggleModuleCollapse = module => {
    this.setState(prevState => {
      const collapsedModules = prevState.collapsedModules.includes(module)
        ? prevState.collapsedModules.filter(item => item !== module)
        : [...prevState.collapsedModules, module];
      return {
        collapsedModules
      };
    });
  };

  getFilteredNotes = () => {
    const { promptsNotes, journalPromptsFilter, userColor } = this.props;
    const filteredNotes = [];
    Object.keys(promptsNotes).forEach((module, moduleIndex) =>
      promptsNotes[module].forEach((note, noteIndex) => {
        const isFounded = note.title
          .toLowerCase()
          .includes(journalPromptsFilter.toLowerCase());
        isFounded &&
          filteredNotes.push(
            <NoteBlock
              key={`${moduleIndex}.${noteIndex}`}
              note={note}
              userColor={userColor}
            />
          );
      })
    );
    return filteredNotes;
  };

  getNotesByModules = () => {
    const { promptsNotes, userColor } = this.props;
    const { collapsedModules } = this.state;
    return Object.keys(promptsNotes)
      .sort()
      .map((module, index) => {
        const notes = promptsNotes[module];
        const title = module.replace('_', ' ');
        const isOpened = collapsedModules.includes(module);
        if (notes.length === 0) {
          return null;
        }
        return (
          <Fragment key={index}>
            <h3
              onClick={() => this.toggleModuleCollapse(module)}
              className={cx('module-title')}
            >
              {title}
              <Icon
                type="chevron-up"
                className={cx('chevron', {
                  rotated: isOpened
                })}
              />
            </h3>
            <Collapse isOpened={isOpened}>
              {notes.map((note, index) => (
                <NoteBlock key={index} note={note} userColor={userColor} />
              ))}
            </Collapse>
          </Fragment>
        );
      });
  };

  render() {
    const notes = this.props.journalPromptsFilter
      ? this.getFilteredNotes()
      : this.getNotesByModules();

    return !isEmpty(notes) ? (
      notes
    ) : (
      <Placeholder>No items to display.</Placeholder>
    );
  }
}

JournalPrompts.propTypes = {
  promptsNotes: T.object.isRequired,
  journalPromptsFilter: T.string,
  isLoading: T.bool
};

const enhance = compose(
  connect(
    state => ({
      promptsNotes: getPromptsNotes(state.journals.journalPrompts),
      journalPromptsFilter: state.journals.journalPromptsFilter,
      isLoading: state.journals.isLoading
    }),
    { getJournalPrompts, setActiveNote }
  )
);

export default enhance(JournalPrompts);



// WEBPACK FOOTER //
// ./src/containers/Journal/components/JournalPrompts.jsx